import React, { useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';

const Main = () => {
  const [formData, setFormData] = useState({
    nik: '',
    nama: '',
    hp: '',
    poli: '',
    keluhan: '',
    kategori: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.nik) {
        newErrors.nik = "NIK is required";
    } else if (!/^\d{16}$/.test(formData.nik)) { // Check if NIK is exactly 16 digits
        newErrors.nik = "NIK harus 16 digit angka";
    }
    if (!formData.nama) newErrors.nama = "Nama is required";
    if (!formData.hp) newErrors.hp = "No HP is required";
    if (!formData.keluhan) newErrors.keluhan = "Keluhan is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        await axios.post('https://simanap.rsudkotajambi.id:5000/api/telemedic', {
          ...formData,
        });
        Swal.fire({
          icon: 'success',
          title: 'Berhasil!',
          text: 'Pendaftaran berhasil dikirim.',
          confirmButtonText: 'OK'
        });
        // Reset form after successful submission
        setFormData({
          nik: '',
          nama: '',
          hp: '',
          poli: '',
          keluhan: '',
          kategori: ''
        });
      } catch (error) {
        console.error("There was an error submitting the form!", error);
        if (error.response) {
          Swal.fire({
              icon: 'error',
              title: 'Gagal!',
              text: error.response.data.error || 'Pendaftaran gagal dikirim.',
              confirmButtonText: 'OK'
          });
        } else {
          Swal.fire({
              icon: 'error',
              title: 'Gagal!',
              text: 'Pendaftaran gagal dikirim.',
              confirmButtonText: 'OK'
          });
        }
      }
    }
};

  return (
    <main className="main">
      <div className="page-title dark-background">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1>Pendaftaran Sistem Konsultasi Medis Online</h1>
              </div>
            </div>
          </div>
        </div>
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/jadwal-dokter">Jadwal Dokter</Link></li>
              <li><Link to="/pendaftaran-online">Pendaftaran Online</Link></li>
              <li className="current">Telemedic</li>
              <li><Link to="/informasi">Informasi</Link></li>
              <li><Link to="/pengaduan">Pengaduan</Link></li>
            </ol>
          </div>
        </nav>
      </div>

      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-12" data-aos="fade-up" data-aos-delay="200">
              <div className="card text-left border-warning cr" data-aos="fade-right">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12 col-sm-12 mt-2">
                        <label htmlFor="nik">NIK</label>
                        <input
                          type="text"
                          name="nik"
                          id="nik"
                          value={formData.nik}
                          onChange={handleChange}
                          className={`form-control ${errors.nik ? 'is-invalid' : ''}`}
                          placeholder="Masukan NIK KTP anda"
                        />
                        {errors.nik && <div className="invalid-feedback">{errors.nik}</div>}
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 col-sm-12 mt-2">
                        <label htmlFor="nama">NAMA</label>
                        <input
                          type="text"
                          name="nama"
                          id="nama"
                          value={formData.nama}
                          onChange={handleChange}
                          className={`form-control ${errors.nama ? 'is-invalid' : ''}`}
                          placeholder="Masukan Nama Anda"
                        />
                        {errors.nama && <div className="invalid-feedback">{errors.nama}</div>}
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 col-sm-12 mt-2">
                        <label htmlFor="hp">NO. HP (whatsapp)</label>
                        <input
                          type="text"
                          name="hp"
                          id="hp"
                          value={formData.hp}
                          onChange={handleChange}
                          className={`form-control ${errors.hp ? 'is-invalid' : ''}`}
                          placeholder="Masukan No telp Anda"
                        />
                        {errors.hp && <div className="invalid-feedback">{errors.hp}</div>}
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 col-sm-12 mt-2">
                        <label htmlFor="poli">KLINIK</label>
                        <select
                          name="poli"
                          id="poli"
                          className="form-control"
                          value={formData.poli}
                          onChange={handleChange}
                          required
                        >
                          <option value="">-Pilih-</option>
                          <option value="22">POLI PENYAKIT DALAM</option>
                          <option value="27">POLI UMUM</option>
                          <option value="30">POLI ANAK</option>
                        </select>
                      </div>
                     <div className="col-lg-6 col-md-6 col-12 col-sm-12 mt-2">
                            <label htmlFor="keluhan">Keluhan</label>
                            <textarea
                                name="keluhan"
                                id="keluhan"
                                className={`form-control ${errors.keluhan ? 'is-invalid' : ''}`}
                                placeholder="Masukan keluhan"
                                value={formData.keluhan}
                                onChange={handleChange}
                                rows={4} // You can adjust the number of rows as needed
                            />
                            {errors.keluhan && <div className="invalid-feedback">{errors.keluhan}</div>}
                        </div>
                      <div className="col-lg-6 col-sm-12 col-md-6 col-12 mt-2">
                        <label htmlFor="kategori">KATEGORI PASIEN</label>
                        <select
                          name="kategori"
                          id="kategori"
                          className="form-control"
                          value={formData.kategori}
                          onChange={handleChange}
                          required
                        >
                          <option value="">-Pilih-</option>
                          <option value="1">Pasien Lama</option>
                          <option value="2">Pasien Baru</option>
                        </select>
                      </div>
                    </div>
                    {/* Daftar button for submitting the form */}
                    <div className="d-flex justify-content-end mt-3">
                      <button type="submit" className="btn btn-success mr-2">Daftar</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Main;
